export const NEVER_EXPIRED = 3000;

export default {};
